import { match } from 'ts-pattern';
import { DeliveryType, FulfillmentOption } from './Constants';

/**
 * In hubless regions, we determine if a delivery is being done by the fulfillment option.
 * @param fulfillmentOption
 */
export function isFulfillmentOptionDelivery(fulfillmentOption: string | null | undefined): boolean {
  return (
    fulfillmentOption === FulfillmentOption.DirectViaShefs || fulfillmentOption === FulfillmentOption.DirectViaNash
  );
}

export function isNoTakeRateFulfillmentOption(fulfillmentOption: string | null): boolean {
  return fulfillmentOption === FulfillmentOption.Pickup || fulfillmentOption === FulfillmentOption.DirectViaShefs;
}

/**
 * Converts a DeliveryType to a FulfillmentOption.
 * @param deliveryType
 */
export function convertDeliveryTypeToFulfillmentOption(deliveryType: DeliveryType | string | null): FulfillmentOption {
  return match(deliveryType)
    .with(DeliveryType.DirectViaShefs, () => FulfillmentOption.DirectViaShefs)
    .with(DeliveryType.DirectViaNash, () => FulfillmentOption.DirectViaNash)
    .with(DeliveryType.Pickup, () => FulfillmentOption.Pickup)
    .otherwise(() => {
      throw new Error(`Cannot convert DeliveryType ${deliveryType} to a FulfillmentOption.`);
    });
}

/**
 * Converts a FulfillmentOption to a DeliveryType
 * @param fulfillmentOption
 */
export function convertFulfillmentOptionToDeliveryType(fulfillmentOption: FulfillmentOption): DeliveryType {
  return match(fulfillmentOption)
    .with(FulfillmentOption.DirectViaShefs, () => DeliveryType.DirectViaShefs)
    .with(FulfillmentOption.DirectViaNash, () => DeliveryType.DirectViaNash)
    .with(FulfillmentOption.Pickup, () => DeliveryType.Pickup)
    .exhaustive();
}

export function getHumanFriendlyString(fulfillmentOption: string | null): string | null {
  return match(fulfillmentOption)
    .with(FulfillmentOption.Pickup, () => 'Customer Pick Up')
    .with(FulfillmentOption.DirectViaShefs, () => 'You Deliver')
    .with(FulfillmentOption.DirectViaNash, () => 'Nash Delivery')
    .otherwise(() => null);
}
